export const UserList = [
    {
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false,
    },
    {
        prop: "code",
        label: "用户代码",
        width: "150",
        format: "",
        order: true,
        isShow: true
    },
    {
        prop: "name",
        label: "用户名称",
        width: "150",
        format: "",
        order: true,
        isShow: true,
        isExport: true,
    },
    {
        prop: "nickName",
        label: "昵称",
        width: "150",
        format: "",
        order: true,
        isShow: true,
        isExport: true,
    },
    {
        prop: "phone",
        label: "手机号",
        width: "150",
        format: "",
        order: false,
        isShow: true,
        isExport: true,
    },
    {
        prop: "type",
        label: "注册方式",
        width: "150",
        format: "registerType",
        order: false,
        isShow: true,
        isExport: true,
    },
    {
        prop: "mail",
        label: "邮箱地址",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "unitName",
        label: "单位名称",
        width: "150",
        format: "",
        order: false,
        isShow: true,
        isExport: true,
    },
    {
        prop: "station",
        label: "岗位角色",
        width: "150",
        format: "",
        order: false,
        isShow: true,
        isExport: true,
    },
    {
        prop: "companyName",
        label: "所属公司",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "provinceName",
        label: "省",
        width: "150",
        isShow: true,
        isExport: true,
    },
    {
        prop: "cityName",
        label: "市",
        width: "150",
        isShow: true,
        isExport: true,
    },
    {
        prop: "regionName",
        label: "区",
        width: "150",
        isShow: true,
        isExport: true,
    },
    {
        prop: "state",
        label: "用户状态",
        width: "150",
        format: "status",
        order: true,
        isShow: true,
        isExport: true,
    },
    {
        prop: "creationTime",
        label: "创建时间",
        width: "150",
        format: "datetime",
        order: true,
        isShow: true,
        isExport: true,
    },
    // {
    //     prop: "creatorId",
    //     label: "创建人",
    //     width: "150",
    //     format: "",
    //     order: false,
    //     isShow: true
    // },
    // {
    //     prop: "lastModificationTime",
    //     label: "修改时间",
    //     width: "150",
    //     format: "datetime",
    //     order: true,
    //     isShow: true
    // },
    // {
    //     prop: "lastModifierId",
    //     label: "修改人",
    //     width: "150",
    //     format: "",
    //     order: false,
    //     isShow: true
    // }
]



